import React, { Fragment } from 'react';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

const ReactTableActions = ({data, Callback, AddObservation }) => {
    console.log(data)
    return (<Fragment>
              <td role="cell">
                <div style={{display: 'flex' }}>
                  <div className="form">
                      <div className="form__form-group">
                        <div className="form__form-group-field">
                          <input 
                            type="text" 
                            //value={data.original != undefined? data.original.observacion: ""}
                            //defaultValue={data.original != undefined? data.original.observacion: ""}
                            onChange={(e)=>{
                              AddObservation(data.data.index, e.target.value)
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div style={{ marginLeft: 10 }}>
                      <DeleteForeverIcon onClick={()=>{
                          console.log("delete");
                          Callback();
                        }}
                      />
                    </div> */}
                  </div>
              </td>
            </Fragment>)
  }

export default ReactTableActions; 